import React, { useEffect, useState } from 'react';
import { ReportTable } from 'src/components/auditReports/reportTable';
import { ListReportsInput } from 'aws-sdk/clients/d3aservice';
import { activeGroupOrWorkspaceId } from 'src/components/dataadvisory/constants';
import { listReports } from 'src/api/d3a';
import { Button, Header, SpaceBetween } from '@amzn/awsui-components-react-v3';
import { Page } from 'src/routes';
import { CommonPageProps } from '../common/CommonPageProps';
import { CompareReportsModal } from './compareReportsModal';

export interface ListReportsPageProps extends CommonPageProps {
  activeGroup: string;
  activeWorkspace?: any;
  setNotifications?: any;
}

export const ListReportsPage = (props: ListReportsPageProps) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [reports, setReports] = useState([]);
  const [nextToken, setNextToken] = useState<string>(undefined);
  const [selectedReports, setSelectedReports] = useState([]);
  const [compareModalVisible, setCompareModalVisible] = useState(false);

  const handleRefresh = async () => {
    setLoading(true);
    try {
      const listReportsInput: ListReportsInput = {
        ownerId: activeGroupOrWorkspaceId(props),
      };
      const listReportsOutput = await listReports(listReportsInput);

      // filter to show only parent reports and not dependent ones.
      const parentReports = listReportsOutput.reports.filter((rep) => rep.reportId == rep.metadataId);
      setReports(parentReports);
      setNextToken(listReportsOutput.nextToken);
    } catch (e) {
      console.log('Failed to load reports: ', e);
      props.setNotifications([
        {
          type: 'error',
          content: 'Failed to load reports: ' + e.message,
          dismissible: true,
          onDismiss: () => props.setNotifications([]),
        },
      ]);
    }
    setLoading(false);
  };

  const loadMore = async () => {
    if (!nextToken) return;
    setLoading(true);
    try {
      const listReportsInput: ListReportsInput = {
        ownerId: activeGroupOrWorkspaceId(props),
        nextToken: nextToken,
      };
      const listReportsOutput = await listReports(listReportsInput);
      const parentReports = listReportsOutput.reports.filter((rep) => rep.reportId == rep.metadataId);
      const newReports = [...reports, ...parentReports];
      setReports(newReports);
      setNextToken(listReportsOutput.nextToken);
    } catch (e) {
      console.log('Failed to load more reports: ', e);
      props.setNotifications([
        {
          type: 'error',
          content: 'Failed to load reports: ' + e.message,
          dismissible: true,
          onDismiss: () => props.setNotifications([]),
        },
      ]);
    }
    setLoading(false);
  };

  const redirectToCreateReportPage = () => {
    props.setRedirect(Page.START_REPORT_GENERATION);
  };

  useEffect(() => {
    handleRefresh();
  }, []);

  return (
    <>
      <CompareReportsModal
        visible={compareModalVisible}
        onDismiss={() => setCompareModalVisible(false)}
        selectedReports={selectedReports}
        activeGroup={props.activeGroup}
        activeWorkspace={props.activeWorkspace}
        setNotifications={props.setNotifications}
        setRedirect={props.setRedirect}
      />
      <SpaceBetween size={'l'} direction={'vertical'}>
        <Header
          variant={'h1'}
          actions={
            <Button variant={'primary'} onClick={redirectToCreateReportPage}>
              Create report
            </Button>
          }
        >
          Audit reports
        </Header>
        <ReportTable
          setContentType={props.setContentType}
          activeGroup={props.activeGroup}
          activeWorkspace={props.activeWorkspace}
          reports={reports}
          loading={loading}
          handleRefresh={handleRefresh}
          nextToken={nextToken}
          loadMoreResults={loadMore}
          onSelectionChange={setSelectedReports}
          selectedReports={selectedReports}
          onCompareReports={() => setCompareModalVisible(true)}
        />
      </SpaceBetween>
    </>
  );
};
